module.exports = __webpack_public_path__ + "static/media/team_1.daea9fbe.png";